<template>
  <div class="withdraw-page">
    <!-- 返回按鈕 -->
    <el-button 
      icon="el-icon-arrow-left" 
      class="back-btn"
      @click="$router.go(-1)"
      plain
    >返回</el-button>

    <div class="withdraw-container">
      <!-- 提現卡片 -->
      <el-card class="withdraw-card">
        <div class="card-header">
          <h2>提現申請</h2>
          <div class="balance-info">
            <!-- {{ UserInfoData }} -->
            可提餘額：HKD {{ Number(UserInfoData.proxy_balance / 100).toFixed(2) }}
          </div>
        </div>

        <!-- 提現表單 -->
        <el-form 
          ref="form"
          :model="form"
          :rules="rules"
          label-position="top"
          @submit.native.prevent="submitForm"
        >
          <!-- 金額輸入 -->
          <el-form-item label="提現金額" prop="amount">
            <el-input
              v-model.number="form.amount"
              type="number"
              placeholder="請輸入提現金額(HKD)"
              :min="1"
              :max="UserInfoData.proxy_balance / 100"
            >
            </el-input>
            <div class="input-tips">
              <span>單筆最低 {{ minAmount }} HKD</span>
            </div>
          </el-form-item>

          <!-- TRC地址輸入 -->
          <el-form-item label="TRC20錢包地址" prop="address">
            <el-input
              v-model="form.address"
              placeholder="請輸入TRC20錢包地址"
              clearable
            >
            </el-input>
            <div class="input-tips">
              請確認地址正確，轉賬後不可撤回
            </div>
          </el-form-item>

          <!-- 提交按鈕 -->
          <el-form-item>
            <el-button
              class="submit-btn"
              native-type="submit"
              :loading="loading"
            >
              立即提現
            </el-button>
          </el-form-item>
        </el-form>
      </el-card>

      <!-- 成功提示 -->
      <el-dialog
        title="提現成功"
        :visible.sync="successVisible"
        width="90%"
        center
        mask
        @closed="clickSuccess"
      >
        <div class="success-content">
          <i class="el-icon-circle-check success-icon"></i>
          <p>您的提現申請已提交審核</p>
          <p>預計到賬時間：1-3個工作日</p>
        </div>
        <span slot="footer">
          <el-button 
            type="primary"
            @click="clickSuccess()"
          >確定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WithdrawPage',
  data() {
    // 金額驗證規則
    const validateAmount = (rule, value, callback) => {
      if (!value) {
        callback(new Error('請輸入提現金額'))
      } else if (value < this.minAmount) {
        callback(new Error(`最低提現金額 ${this.minAmount} HKD`))
      } else if (value > this.UserInfoData.proxy_balance / 100) {
        callback(new Error('餘額不足'))
      } else {
        callback()
      }
    }

    // 地址驗證規則
    const validateAddress = (rule, value, callback) => {
      const trc20Regex = /^T[a-zA-Z0-9]{33}$/
      if (!value) {
        callback(new Error('請輸入錢包地址'))
      } else if (!trc20Regex.test(value)) {
        callback(new Error('請輸入有效的TRC20地址'))
      } else {
        callback()
      }
    }

    return {
      form: {
        amount: null,
        address: ''
      },
      rules: {
        amount: [{ validator: validateAmount, trigger: 'blur' }],
        address: [{ validator: validateAddress, trigger: 'blur' }]
      },
      loading: false,
      successVisible: false,
      minAmount: 10,    // 最低提現金額
      availableBalance: 1500, // 示例餘額
      UserInfoData: {}
    }
  },
  mounted() {
     // 刷新用戶信息
    this.refreshUser()
  },
  methods: {
    clickSuccess() {
      this.$router.go(-1)
    },
    refreshUser() {
      this.$axios.get("/api/user/info").then(res => {
        this.UserInfoData = res.data.data
      })
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.handleWithdraw()
        }
      })
    },
    async handleWithdraw() {
      this.loading = true
      try {
        // 調用提現API
        await this.$axios.post('/api/proxy_order/add', {
          amount: this.form.amount * 100, // 轉為分單位
          address: this.form.address
        })
        
        this.successVisible = true
        this.resetForm()
      } catch (error) {
        this.$message.error(error.response?.data?.message || '提交失敗')
      } finally {
        this.loading = false
      }
    },
    resetForm() {
      this.$refs.form.resetFields()
    }
  }
}
</script>

<style scoped>
.withdraw-page {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}

.back-btn {
  margin-bottom: 20px;
}

.withdraw-card {
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.card-header {
  text-align: center;
  margin-bottom: 30px;
}

.card-header h2 {
  color: #3E4F7A;
  margin-bottom: 8px;
}

.balance-info {
  color: #3E4F7A;
  font-size: 16px;
  font-weight: 500;
}

.input-tips {
  font-size: 12px;
  color: #909399;
  margin-top: 8px;
  display: flex;
  justify-content: space-between;
}

.submit-btn {
  width: 100%;
  height: 48px;
  font-size: 16px;
  margin-top: 20px;
  background-color: #3E4F7A;
  color: white;
}

.success-content {
  text-align: center;
  padding: 20px;
}

.success-icon {
  color: #3E4F7A;
  font-size: 48px;
  margin-bottom: 16px;
}

/* 金額輸入樣式調整 */
::v-deep .el-input-group__append {
  background-color: #f5f7fa;
  color: #3E4F7A;
  font-weight: 500;
}
</style>
